package fr.labodoc.healthProfessional.webApp.pages.dashboard

import fr.labodoc.healthProfessional.webApp.pages.dashboard.components.MedicineList
import fr.labodoc.healthProfessional.webApp.pages.dashboard.components.MedicineListViewModel
import fr.labodoc.healthProfessional.webApp.pages.dashboard.components.Messages
import fr.labodoc.require
import io.kvision.core.Container
import io.kvision.html.div
import io.kvision.panel.SimplePanel
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import org.koin.core.parameter.parametersOf

class DashboardPage(
  atcClassificationCode: String?
) : SimplePanel(), KoinComponent {
  private val medicineListViewModel: MedicineListViewModel by inject { parametersOf(atcClassificationCode) }

  init {
    id = "page-dashboard"
    require("./css/pages/dashboard/dashboard.css")

    div(className = "medical-items-with-messages") {
      add(Messages())

      add(MedicineList(medicineListViewModel))
    }
  }
}

fun Container.dashboardPage(
  atcClassificationCode: String?
): DashboardPage {
  val dashboardPage = DashboardPage(atcClassificationCode)

  this.add(dashboardPage)
  return dashboardPage
}

